import * as React from 'react';
import { useContext } from 'react';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import Image from 'next/image';
import { modalContext } from '../../../Layout';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  StModalContainerWithModal,
  StmodalContainer,
  StHeadingContainer,
  StDescriptionText,
  StFooterbuttons,
} from './DisclaimerModal.style';
import CloseIcon from '../../../../public/close-icon.png';
import UiHeading from '../../shared/Heading';
import ButtonPrimary from '../../shared/Button/PrimaryButton';
import UiBox from '../../shared/Box';
import ButtonDiscreet from '../../shared/Button/ButtonDiscreet';

interface IModalDataProps {
  isDisclaimerEnable: Field<boolean>;
  disclaimerHeading: Field<string>;
  disclaimerDescription: Field<string>;
  cancelText: Field<string>;
  continueText: Field<string>;
  ariaLabel: Field<string>;
}

interface IModalProps {
  modalData: IModalDataProps;
}

function DisclaimerModal(props: IModalProps): JSX.Element {
  const { modalData } = props;
  const modalState = useContext(modalContext);
  const { open, closeModal } = modalState;

  const handleClose = (_event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') {
      closeModal();
    }
  };

  function onContinue() {
    window.open(modalState?.link);
    closeModal();
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown={true}
      >
        <StModalContainerWithModal>
          <StmodalContainer>
            <StHeadingContainer>
              <UiHeading id="modal-modal-title" size="h6">
                {modalData?.disclaimerHeading?.value}
              </UiHeading>
              <IconButton
                color="inherit"
                aria-label={modalData?.ariaLabel?.value}
                edge="start"
                onClick={closeModal}
              >
                <Image alt="close-icon" src={CloseIcon} width={12} height={12} />
              </IconButton>
            </StHeadingContainer>
            <StDescriptionText id="modal-modal-description">
              {modalData?.disclaimerDescription?.value}
            </StDescriptionText>
            <StFooterbuttons>
              <ButtonDiscreet onClick={closeModal}>{modalData?.cancelText?.value}</ButtonDiscreet>
              <UiBox styles={{ paddingLeft: '10px' }}>
                <ButtonPrimary onClick={onContinue}>{modalData?.continueText?.value}</ButtonPrimary>
              </UiBox>
            </StFooterbuttons>
          </StmodalContainer>
        </StModalContainerWithModal>
      </Modal>
    </div>
  );
}

export default DisclaimerModal;
